export default __webpack_public_path__ + "static/SRUS LF320 - Especification Del Producto y Datos Técnicos-4ad0a4d09ed57c9902d5ae9d96fdcd5b.pdf";